import { BaseHTMLElement } from '../ui/BaseHTMLElement';
import { AuthManager } from './AuthManager';

export class AuthForm extends BaseHTMLElement {
  private authManager: AuthManager;
  private isLoginMode: boolean = true;
  private onSuccess: () => void;

  constructor(onSuccess: () => void) {
    super('div', 'auth-form');
    this.authManager = AuthManager.getInstance();
    this.onSuccess = onSuccess;
    this.render();
  }

  private render(): void {
    this.element.innerHTML = `
      <div class="auth-container">
        <div class="auth-card">
          <div class="auth-header">
            <h1>Welcome to Salmon</h1>
            <p>${this.isLoginMode ? 'Sign in to your account' : 'Create a new account'}</p>
          </div>
          
          <form class="auth-form-content" id="auth-form">
            ${!this.isLoginMode ? `
              <div class="form-group">
                <label for="name">Name</label>
                <input type="text" id="name" name="name" required>
              </div>
            ` : ''}
            
            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" id="email" name="email" required>
            </div>
            
            <div class="form-group">
              <label for="password">Password</label>
              <input type="password" id="password" name="password" required>
            </div>
            
            <div class="form-actions">
              <button type="submit" class="btn-primary">
                ${this.isLoginMode ? 'Sign In' : 'Sign Up'}
              </button>
            </div>
          </form>
          
          <div class="auth-footer">
            <p>
              ${this.isLoginMode ? "Don't have an account?" : "Already have an account?"}
              <a href="#" id="toggle-mode">
                ${this.isLoginMode ? 'Sign up' : 'Sign in'}
              </a>
            </p>
          </div>
          
          <div class="error-message" id="error-message" style="display: none;"></div>
        </div>
      </div>
    `;

    this.setupEventListeners();
  }

  private setupEventListeners(): void {
    const form = this.element.querySelector('#auth-form') as HTMLFormElement;
    const toggleMode = this.element.querySelector('#toggle-mode') as HTMLAnchorElement;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      await this.handleSubmit();
    });

    toggleMode.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleMode();
    });
  }

  private async handleSubmit(): Promise<void> {
    const form = this.element.querySelector('#auth-form') as HTMLFormElement;
    const formData = new FormData(form);
    const errorMessage = this.element.querySelector('#error-message') as HTMLElement;
    const submitButton = form.querySelector('button[type="submit"]') as HTMLButtonElement;

    // Hide previous error
    errorMessage.style.display = 'none';

    // Disable submit button
    submitButton.disabled = true;
    submitButton.textContent = this.isLoginMode ? 'Signing In...' : 'Signing Up...';

    try {
      const email = formData.get('email') as string;
      const password = formData.get('password') as string;

      if (this.isLoginMode) {
        await this.authManager.login(email, password);
      } else {
        const name = formData.get('name') as string;
        await this.authManager.signup(name, email, password);
      }

      this.onSuccess();
    } catch (error) {
      errorMessage.textContent = error instanceof Error ? error.message : 'An error occurred';
      errorMessage.style.display = 'block';
    } finally {
      // Re-enable submit button
      submitButton.disabled = false;
      submitButton.textContent = this.isLoginMode ? 'Sign In' : 'Sign Up';
    }
  }

  private toggleMode(): void {
    this.isLoginMode = !this.isLoginMode;
    this.render();
  }
}
